import placeholder from 'shared/assets/images/property.svg';
import { Image } from 'widgets/Image';

interface PropertyImageProps {
    src?: string | null;
}

export const PropertyImage = ({ src }: PropertyImageProps) => {
    return (
        <Image
            src={src}
            style={{
                aspectRatio: '380/220',
                maxWidth: '570px',
                height: 'auto',
                width: '100%',
            }}
            imageStyle={{
                objectFit: 'cover',
            }}
            placeholder={placeholder}
        />
    );
};
